<!--消费折扣-->
<template>
  <div>

    <div class="content-header">
      <div class="left">
        <span class="title">消费折扣</span>
      </div>
      <div class="right">
        <Button type="primary" @click="openModal">新增折扣活动</Button>
      </div>
    </div>
    <Alert show-icon>消费折扣定义：指会员单次支付的订单金额达到一定的数额，便可享受对应的打折优惠，详见活动创建页面。</Alert>

    <div class="content-header">
      <div class="left">
        <Input v-model="page.value" placeholder="根据条件搜索" @on-enter="getData(1)" style="width: 350px">
        <Select v-model="page.cond" slot="prepend" style="width: 150px">
          <Option value="id">活动ID</Option>
          <Option value="name">活动名称</Option>
          <Option value="agent_name" v-if="!agent.tp">合作伙伴</Option>
        </Select>
        <Button slot="append" icon="ios-search" @click="getData(1)"></Button>
        </Input>
        <Button @click="resetParams" style="margin-left: 5px">重置</Button>
        <Select v-model="page.is_del" style="width: 120px; margin-left: 10px" @on-change="getData(1)">
          <Option :value="0">正常</Option>
          <Option :value="1">已删除</Option>
        </Select>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="data" :loading="tableLoading" @on-expand="getMachines" />
      <div class="t-right">
        <Page @on-change="pageChange" @on-page-size-change="sizeChange" :current="page.p + 1" :total="total"
          show-elevator show-sizer show-total />
      </div>
    </div>
    <Modal v-model="visible" :title="current.id ? '修改折扣活动' : '新增折扣活动'" width="800" :closable="true">
      <Form ref="forms" :model="current" :rules="rule" class="form">
        <FormItem label="合作伙伴:" prop="agent_id" v-if="!agent.tp">
          <Select v-model="current.agent_id" style="width: 260px" filterable placeholder="请选择">
            <Option v-for="(item, index) in agents" :key="index" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="活动名称:" prop="name">
          <div style="display: flex; align-items: center; gap: 16px;">
            <Input v-model="current.name" placeholder="活动名称" style="width: 260px" />
            <div style="display: flex; align-items: center; gap: 8px;">
              <span style="white-space: nowrap;">用户类型:</span>
              <Select v-model="current.user_type" style="width: 260px">
                <Option :value="0">不限</Option>
                <Option :value="1">普通会员</Option>
                <Option :value="2">企业会员</Option>
              </Select>
            </div>
          </div>
        </FormItem>
        <FormItem label="优惠券限制:">
          <RadioGroup v-model="current.coupon_allowed">
            <Radio :label="1">允许</Radio>
            <Radio :label="0">不允许</Radio>
          </RadioGroup>
          <div class="describe" style="margin-top: 6px;margin-left:85px">优惠券与折扣活动是否允许同时生效</div>
        </FormItem>

        <FormItem label="使用规则:" class="usage-rules-item">
          <div class="">
            <div class="usage-text describe1">
              每种色彩订单最多可设置3种规则的折扣方案，至少要设置一条规则。如消费满10元打8折，则达到金额填10享受折扣填8
              <!-- <div class="usage-examples" style="margin-top:8px;">
                <div>示例一：订单类型 <strong>黑白</strong>，达到金额 <strong>10</strong> 元，享受折扣 <strong>9.5</strong> 折</div>
                <div>示例二：订单类型 <strong>彩色</strong>，达到金额 <strong>30</strong> 元，享受折扣 <strong>9.0</strong> 折</div>
              </div> -->
            </div>
            <Button type="primary" size="small" @click="addRule">添加规则</Button>
          </div>
        </FormItem>

        <div class="rule-list">
          <div class="rule-item" v-for="(item, index) in current.rules" :key="index">
            <FormItem :label="`规则${index + 1}:`">
            </FormItem>

            <FormItem label="订单类型:" :prop="`rules.${index}.color`">
              <Select v-model="item.color" class="rule-select" placeholder="选择订单色彩">
                <Option :value="0">黑白</Option>
                <Option :value="1">彩色</Option>
              </Select>
            </FormItem>

            <FormItem label="达到金额:" :prop="`rules.${index}.amount`">
              <div class="input-with-unit">
                <InputNumber v-model="item.amount" placeholder="达到金额" class="rule-input" @on-blur="normalizeAmount(item)"
                  :active-change="false" :min="0.01" :step="0.01" :precision="2" />
                <span class="unit">元</span>
              </div>
            </FormItem>
            <FormItem label="享受折扣:" :prop="`rules.${index}.discount`">
              <div class="input-with-unit">
                <InputNumber v-model="item.discount" placeholder="享受折扣" class="rule-input"
                  @on-blur="normalizeDiscount(item)" :active-change="false" :step="0.1" :precision="1" :min="1" :max="10" />
                <span class="unit">折</span>
              </div>
            </FormItem>
            <div class="rule-action">
              <Button type="error" size="small" icon="md-close" shape="circle" v-if="current.rules.length > 1"
                @click="deleteRule(index)"></Button>
            </div>
          </div>
        </div>
      </Form>
      <div slot="footer" class="modal-footer-actions">
        <Button size="large" @click="visible = false">取消</Button>
        <Button type="primary" size="large" @click="modalClick" :loading="modalLoading">确定</Button>
      </div>
    </Modal>

    <Modal v-model="bind_visible" width="300" :title="`折扣绑定 - ${bind_data.name}`">
      <Input autofocus search ref="search" enter-button="搜索" v-model="bind_search" @on-search="getMachine"
        style="width: 268px" placeholder="输入完整设备序列号" />
      <Spin v-if="bind_spin" fix></Spin>
      <Alert v-if="bind_machine.id" style="margin-top: 10px; padding-right: 16px"
        :type="bind_machine.discount_id ? 'warning' : 'success'">
        <div class="alert-content">
          <span v-if="!bind_machine.discount_id">是否将此活动绑定该设备上?
          </span>
          <span v-if="bind_machine.discount_id">设备已绑定折扣活动,是否覆盖? </span>
          <Button type="primary" size="small" @click="bindData">确定</Button>
        </div>
      </Alert>
      <div slot="footer" style="padding: 0; border: none"></div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import expand from './expand.vue'
import {
  GetDiscountList,
  GetDiscountInfo,
  SaveDiscount,
  DeleteDiscount,
  RestoreDiscount,
  BindMachineDiscount,
  GetMachinesByDiscount
} from '@/api/discount'
export default {
  components: { expand },
  data () {
    return {
      data: [],
      columns: [
        {
          type: 'expand',
          width: 100,
          render: (h, data) => {
            return h(
              expand,
              {
                props: {
                  row: data.row
                },
                ref: `expand_${data.row.id}`
              },
              ''
            )
          }
        },
        { key: 'id', minWidth: 90, title: '活动ID' },
        { key: 'agent_name', title: '合作伙伴', minWidth: 150 },
        { key: 'name', title: '活动名称', minWidth: 200 },
        {
          key: 'coupon_allowed',
          title: '优惠券限制',
          minWidth: 120,
          render: (h, data) => {
            return h('span', {}, data.row.coupon_allowed == 1 ? '允许' : '不允许')
          }
        },
        {
          key: 'discount_rules',
          title: '折扣规则',
          minWidth: 300,
          render: (h, data) => {
            try {
              const rules = typeof data.row.discount_rules === 'string'
                ? JSON.parse(data.row.discount_rules)
                : data.row.discount_rules
              if (!rules || !Array.isArray(rules) || rules.length === 0) {
                return h('span', {}, '-')
              }
              const ruleTexts = rules.map(rule => {
                const colorText = rule.color == 0 ? '黑白' : '彩色'
                return `${colorText}满${rule.amount}元${rule.discount}折`
              })
              return h('span', {}, ruleTexts.join('；'))
            } catch (e) {
              return h('span', {}, '-')
            }
          }
        },
        {
          key: 'create_time',
          title: '创建时间',
          minWidth: 180,
          render: (h, data) => {
            console.log('data.row.create_time', data.row.create_time)
            return h('span', {}, data.row.create_time ? this.$moment(data.row.create_time, 'YYYY-MM-DD HH:mm:ss') : '-')
          }
        },
        {
          key: 'operator',
          title: '操作',
          export_ignore: true,
          minWidth: 180,
          align: 'right',
          render: (h, data) => {
            let temp = []
            if (data.row.is_del == 0) {
              temp.push(
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'info' },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.editDiscount(data.row)
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'warning' },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.openBind(data.row)
                      }
                    }
                  },
                  '绑定'
                ),
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'error' },
                    on: {
                      click: () => {
                        this.deleteDiscount(data.row)
                      }
                    }
                  },
                  '删除'
                )
              )
            } else {
              temp.push(
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'success' },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.restoreDiscount(data.row)
                      }
                    }
                  },
                  '恢复'
                )
              )
            }
            return h('span', {}, temp)
          }
        }
      ],
      current: {
        id: null,
        agent_id: 0,
        name: '',
        user_type: 0,
        coupon_allowed: 0,
        rules: []
      },
      rule: {
        name: [{ required: true, message: '请填写活动名称', trigger: 'blur' }],
        agent_id: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.agent.tp && !value) {
                callback(new Error('请选择合作伙伴'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      agents: [],
      visible: false,
      modalLoading: false,
      tableLoading: false,
      bind_visible: false,
      bind_spin: false,
      bind_data: {},
      bind_machine: {},
      bind_search: '',
      page: {
        p: 0,
        l: 10,
        value: '',
        cond: 'id',
        is_del: 0
      },
      total: 0
    }
  },
  mounted () {
    this.getData()
    // 如果不是代理商，获取合作伙伴列表
    if (!this.agent.tp) {
      this.getAgentList({
        l: 1000,
        cond: 'id',
        value: '',
        is_del: 0,
        senior: '',
        key: 'id',
        order: 'desc'
      }).then(res => {
        this.agents = res.data
      })
    }
  },
  methods: {
    getMachines (data, status) {
      // expand组件会自己处理数据获取
    },
    bindData () {
      BindMachineDiscount({
        machine_id: this.bind_machine.id,
        discount_id: this.bind_data.id
      }).then(res => {
        const result = res.data
        if (result.status) {
          this.$Message.success('绑定成功')
          // 如果expand组件存在，刷新其数据
          this.getData()
          this.bind_machine = {}
          this.bind_search = ''
          this.$refs.search.focus()
        } else {
          this.$Message.error(result.msg || '绑定失败')
        }
      }).catch(err => {
        this.$Message.error('绑定失败')
      })
    },
    getMachine (value) {
      if (value) {
        this.bind_spin = true
        // 这里需要调用获取机器信息的API，暂时使用一个通用的方法
        // 假设有一个machineInfo方法，类似machine-activity页面
        this.machineInfo({ sn: value }).then((res) => {
          this.bind_spin = false
          if (res.id) {
            this.bind_machine = res
          } else {
            this.$Message.warning('未找到设备')
          }
        }).catch(err => {
          this.bind_spin = false
          this.$Message.warning('未找到设备')
        })
      }
    },
    openBind (data) {
      this.bind_visible = true
      this.bind_data = data
    },
    validateRuleColor (rule, value, callback) {
      // 允许值 0 或 1
      if (value === 0 || value === 1) {
        callback()
      } else {
        callback(new Error('请选择订单色彩'))
      }
    },
    validateRuleAmount (rule, value, callback) {
      const v = Number(value)
      const isTwoDecimals = !isNaN(v) && Math.round(v * 100) / 100 === v
      if (!isNaN(v) && v > 0 && isTwoDecimals) {
        callback()
      } else {
        callback(new Error('请输入达到金额，最多两位小数'))
      }
    },
    validateRuleDiscount (rule, value, callback) {
      const v = Number(value)
      if (!isNaN(v) && v > 0 && v <= 10 && Math.round(v * 10) / 10 === v) {
        callback()
      } else {
        callback(new Error('请输入享受折扣，最多一位小数，范围 0-10'))
      }
    },
    normalizeAmount (item) {
      if (item && item.amount !== undefined && item.amount !== null) {
        const v = parseFloat(item.amount)
        if (isNaN(v) || v <= 0) {
          item.amount = null
        } else {
          item.amount = Math.round(v * 100) / 100
        }
      }
    },
    normalizeDiscount (item) {
      if (item && item.discount !== undefined && item.discount !== null) {
        const v = parseFloat(item.discount)
        if (isNaN(v) || v <= 0) {
          item.discount = null
        } else {
          item.discount = Math.round(v * 10) / 10
        }
      }
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      this.tableLoading = true
      GetDiscountList(this.page).then(res => {
        this.tableLoading = false
        // 后端返回格式：{total: 0, data: []}
        console.log('res.data', res.data.total)
        if (res.data.total) {
          this.data = res.data.data
          this.total = res.data.total || 0
        } else {
          this.data = []
          this.total = 0
        }
      }).catch(err => {
        this.tableLoading = false
        this.$Message.error('获取列表失败')
        this.data = []
        this.total = 0
      })
    },
    openModal () {
      this.$nextTick(() => {
        this.current = {
          id: 0,
          agent_id: 0,
          name: '',
          user_type: 0,
          coupon_allowed: 0,
          rules: [{ color: -1, amount: null, discount: null }]
        }
      })
      this.visible = true
    },
    editDiscount (row) {
      GetDiscountInfo({ id: row.id }).then(res => {
        // 后端返回：找到记录时直接返回数据对象，没找到时返回{status: false, msg: '...'}
        if (res.data.status === false) {
          this.$Message.error(res.msg || '获取详情失败')
          return
        }

        // 如果返回的是数据对象（有id字段）
        if (res.data.id) {
          let current = {
            id: res.data.id,
            agent_id: res.data.agent_id || 0,
            name: res.data.name || '',
            user_type: res.data.user_type !== undefined ? res.data.user_type : 0,
            coupon_allowed: res.data.coupon_allowed !== undefined ? res.data.coupon_allowed : 0,
            rules: []
          }
          // 解析折扣规则
          try {
            const rules = typeof res.data.discount_rules === 'string'
              ? JSON.parse(res.data.discount_rules)
              : res.data.discount_rules
            console.log('rules', rules)
            if (rules && Array.isArray(rules) && rules.length > 0) {
              // normalize rules to ensure reactivity and correct types/defaults
              current.rules = rules.map(rule => {
                return {
                  color: (rule.color === 0 || rule.color === 1) ? rule.color : -1,
                  amount: rule.amount != null ? (isNaN(parseFloat(rule.amount)) ? null : Math.round(parseFloat(rule.amount) * 100) / 100) : null,
                  discount: rule.discount != null ? (isNaN(parseFloat(rule.discount)) ? null : Math.round(parseFloat(rule.discount) * 10) / 10) : null
                }
              })
              // force re-render in case Vue didn't pick up deep changes
            } else {
              current.rules = [{ color: 0, amount: null, discount: null }]
            }
            this.$nextTick(() => {
              this.current = current
            })
          } catch (e) {
            this.current.rules = [{ color: 0, amount: null, discount: null }]
          }
          this.visible = true
        } else {
          this.$Message.error('获取详情失败')
        }
      }).catch(err => {
        this.$Message.error('获取详情失败')
      })
    },
    addRule () {
      // 最多允许 3 条规则（总体）
      // if (this.current.rules && this.current.rules.length >= 3) {
      //   this.$Message.warning("最多只能添加3条规则");
      //   return;
      // }
      // 检查每种颜色是否已有3条规则
      const colorCounts = {}
      this.current.rules.forEach(rule => {
        if (rule.color !== undefined && rule.color !== null) {
          colorCounts[rule.color] = (colorCounts[rule.color] || 0) + 1
        }
      })

      // 检查是否还有颜色可以添加规则
      const canAddColor = [0, 1].find(color => (colorCounts[color] || 0) < 3)

      if (canAddColor === undefined) {
        this.$Message.warning('每种色彩的订单最多可设置3种规则')
        return
      }

      this.current.rules.push({
        color: -1,
        amount: null,
        discount: null
      })
    },
    deleteRule (index) {
      if (this.current.rules.length > 1) {
        this.current.rules.splice(index, 1)
      } else {
        this.$Message.warning('至少需要保留一条规则')
      }
    },
    modalClick () {
      this.$refs.forms.validate(valid => {
        if (valid) {
          // 验证规则
          if (!this.current.rules || this.current.rules.length === 0) {
            this.$Message.error('至少需要设置一条规则')
            return
          }

          // 验证每条规则
          let hasError = false
          for (let i = 0; i < this.current.rules.length; i++) {
            const rule = this.current.rules[i]
            console.log('rule', rule)
            if (rule.color === undefined || rule.color === null || rule.color === -1) {
              this.$Message.error(`规则${i + 1}：请选择订单色彩`)
              hasError = true
              break
            }
            const amountVal = Number(rule.amount)
            const isTwoDecimalAmount =
              !isNaN(amountVal) && Math.round(amountVal * 100) / 100 === amountVal
            if (
              isNaN(amountVal) ||
              amountVal <= 0 ||
              !isTwoDecimalAmount
            ) {
              this.$Message.error(`规则${i + 1}：请输入达到金额`)
              hasError = true
              break
            }
            const discountVal = Number(rule.discount)
            const isOneDecimal =
              !isNaN(discountVal) && Math.round(discountVal * 10) / 10 === discountVal
            if (
              isNaN(discountVal) ||
              discountVal < 1 ||
              discountVal > 10 ||
              !isOneDecimal
            ) {
              this.$Message.error(`规则${i + 1}：请输入正确的折扣（1-10之间，最多一位小数）`)
              hasError = true
              break
            }
          }

          if (hasError) {
            return
          }

          // 检查每种颜色是否超过3条规则
          const colorCounts = {}
          this.current.rules.forEach(rule => {
            colorCounts[rule.color] = (colorCounts[rule.color] || 0) + 1
          })

          for (let color in colorCounts) {
            if (colorCounts[color] > 3) {
              this.$Message.error(`每种色彩的订单最多可设置3种规则`)
              return
            }
          }

          this.modalLoading = true
          const data = {
            id: this.current.id,
            agent_id: this.current.agent_id,
            name: this.current.name.trim(),
            coupon_allowed: this.current.coupon_allowed,
            user_type: this.current.user_type,
            discount_rules: JSON.stringify(this.current.rules)
          }

          SaveDiscount(data).then(res => {
            this.modalLoading = false
            if (res.data.status) {
              this.$Message.success(this.current.id ? '修改成功' : '新增成功')
              this.visible = false
              this.getData()
            } else {
              this.$Message.error(res.data.msg || '操作失败')
            }
          }).catch(err => {
            this.modalLoading = false
            this.$Message.error('操作失败')
          })
        }
      })
    },
    deleteDiscount (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除折扣活动"${row.name}"吗？删除将解绑所有绑定此活动的设备`,
        onOk: () => {
          DeleteDiscount({ id: row.id, unBind: true }).then(res => {
            if (res.status) {
              this.$Message.success('删除成功')
              this.getData()
            } else {
              this.$Message.error(res.msg || '删除失败')
            }
          }).catch(err => {
            this.$Message.error('删除失败')
          })
        }
      })
    },
    restoreDiscount (row) {
      this.$Modal.confirm({
        title: '确认恢复',
        content: `确定要恢复折扣活动"${row.name}"吗？`,
        onOk: () => {
          RestoreDiscount({ id: row.id }).then(res => {
            if (res.status) {
              this.$Message.success('恢复成功')
              this.getData()
            } else {
              this.$Message.error(res.msg || '恢复失败')
            }
          }).catch(err => {
            this.$Message.error('恢复失败')
          })
        }
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    resetParams () {
      this.page = {
        p: 0,
        l: 10,
        value: '',
        cond: 'id',
        is_del: 0
      }
      this.getData()
    },
    ...mapActions(['getAgentList', 'machineInfo'])
  },
  computed: mapGetters({
    agent: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
